import React, {useState} from 'react';
import Select from 'react-select';
import { Button, Modal } from 'react-bootstrap';
import ErrorsList from './ErrorsList';
import Thumbnail from './Thumbnail';
import Resizer from "react-image-file-resizer";
import {string2tags, tags2string} from "../_helpers";
import { connect } from "react-redux";

const PostSettings = (props) => {
  const [state, setState] = React.useState({
    _id: props.post ? props.post._id : 0,
    author: props.post ? props.post.author : '',
    authorEmail: props.post ? props.post.authorEmail : '',
    title: props.post ? props.post.title : '',
    sapo: props.post ? props.post.sapo : '',
    createdAt: props.post ? props.post.createdAt : Date.now(),
    category: props.post ? props.post.category : '',
    postType: props.post ? props.post.postType : 0,
    groupId: props.post ? props.post.groupId : 0,
    tags: props.post ? props.post.tags : [],
    mainImage: props.post ? props.post.mainImage : '',
    thumbnail: props.post ? props.post.thumbnail : '',
    body: props.post ? props.post.body : '',
    createdBy: props.auth ? props.auth._id : 0,
    errors: ''
  });

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  React.useEffect(() => {
    setState({
      _id: props.post ? props.post._id : 0,
      author: props.post ? props.post.author : '',
      authorEmail: props.post ? props.post.authorEmail : '',
      title: props.post ? props.post.title : '',
      sapo: props.post ? props.post.sapo : '',
      createdAt: props.post ? props.post.createdAt : Date.now(),
      category: props.post ? props.post.category : '',
      postType: props.post ? props.post.postType : 0,
      groupId: props.post ? props.post.groupId : 0,
      tags: props.post ? props.post.tags : [],
      mainImage: props.post ? props.post.mainImage : '',
      thumbnail: props.post ? props.post.thumbnail : '',
      body: props.post ? props.post.body : '',
      createdBy: props.auth ? props.auth._id : 0,
      errors: ''
    });

  }, [props])


  const catOptions = [
    { value: 1, icon: 'fa-database', label: 'BMF Resources', href: 'https://bmf.mindsponge.info/resources' },
    { value: 2, icon: 'fa-newspaper-o', label: 'BMF Outcomes', href: 'https://bmf.mindsponge.info/outcomes' },
    { value: 3, icon: 'fa-handshake-o', label: 'Collaborative Projects', href: 'https://bmf.mindsponge.info/projects' },
    { value: 4, icon: 'fa-graduation-cap', label: 'Training & Events', href: 'https://bmf.mindsponge.info/events' },
    { value: 5, icon: 'fa-check-square-o', label: 'Credentials', href: 'https://bmf.mindsponge.info/credentials' },
    { value: 6, icon: 'fa-check-square-o', label: 'Science News', href: 'https://bmf.mindsponge.info/credentials' },
    { value: 7, icon: 'fa-check-square-o', label: 'AISDL Products', href: 'https://bmf.mindsponge.info/credentials' },
    { value: 8, icon: 'fa-global', label: 'Worldview', href: 'https://bmf.mindsponge.info/worldview' },
  ];
  
  const onAuthorChange = e => {
    setState({...state, author: e.target.value });
  };
  const onEmailChange = e => {
    setState({...state, authorEmail: e.target.value });
  };
  const onTitleChange = e => {
    setState({...state, title: e.target.value });
  };
  const onCategoryChange = e => {
    setState({...state,  groupId: e.value });
    //setState({...state,  category: e.label });
    //console.log(state, e.value);
  };
  const onSapoChange = e => {
    setState({...state,  sapo: e.target.value });
  };
  const onTagsChange = e => {
    setState({...state,  tags: string2tags(e.target.value) });
  };
  const resizeFile = (file) => new Promise(resolve => {
    Resizer.imageFileResizer(file, 230, 160, 'JPEG', 100, 0,
    uri => {
      resolve(uri);
    }, 'base64' );
  });
  const onThumbnailChange = async (e) => {
    const file = e.target.files[0];
    const image = await resizeFile(file);
    
    setState({...state,  thumbnail: image });
  };
  const renderErrors = () => {
    const { errors } = state;
    if (errors) {
      return <ErrorsList errors={errors} />;
    }
  };

  const onSubmit = e => {
    e.preventDefault();

    const { title, sapo } = state;
    //let body = editorState.getCurrentContent().getPlainText('\u0001');

    const errors = [];
    if (!title || title.length < 4) {
      errors.push('Title should have at least 4 characters.');
    }
    if (!sapo || sapo.length < 4) {
      errors.push('Sapo should have at least 4 characters');
    }
    
    if (errors.length >= 1) {
      setState({...state, errors });
    } else {
      const post = state;
      props.onSubmit(post);
    }
  };

  return (
    <div>
    <Modal show={show} onHide={handleClose} size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered>
      <Modal.Header closeButton>
        <Modal.Title>Post Settings</Modal.Title>
      </Modal.Header>
      <form onSubmit={onSubmit}>
      <Modal.Body>
      {renderErrors()}
        <div className="row">
          <div className="col">
            <label className="form-label">Author</label>
            <input
            type="text"
            className="form-control"
            name="author"
            onChange={onAuthorChange}
            value={state.author}
            maxLength={60}
          />
          </div>
          <div className="col">
          <label className="form-label">Author Email</label>
          <input
            type="email"
            className="form-control"
            name="email"
            onChange={onEmailChange}
            value={state.authorEmail}
            maxLength={60}
          />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="title">Title</label>
          <input
            type="text"
            className="form-control"
            name="title"
            onChange={onTitleChange}
            value={state.title}
            maxLength={260}
          />
        </div>

        <div className="row">
          <div className="col">
            <label className="form-label">Category</label>
            <Select
              value = {
                catOptions.filter(option => 
                    option.value === state.groupId)
              }
              onChange = {onCategoryChange}
              options={catOptions}
              placeholder={"Select a category"}
            />
          </div>
        </div>
        <div className="form-group">
            <label>Sapo</label>
            <textarea
              className="form-control"
              id="sapo"
              name="sapo"
              rows="4"
              onChange={onSapoChange}
              value={state.sapo}
            />
        </div>
        <div className="row">
          <div className="col-md-8">
          <label htmlFor="thumbnail">Image Thumbnail (Optional)</label>
            <input
              id="avatar"
              className="form-control"
              name="thumbnail"
              type="file"
              accept=".jpg,.gif,.png"
              onChange={onThumbnailChange}
              placeholder="Enter URL for the dashboard card image"
            />
          </div>
          <div className='col-md-4'>
            <Thumbnail imageSrc={state.thumbnail} />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="tags">Tags (Separate by ;)</label>
          <input
            type="text"
            className="form-control"
            name="tags"
            onChange={onTagsChange}
            value={tags2string(state.tags)}
            maxLength={160}
          />
        </div>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" type="submit">
          Save
        </Button>
      </Modal.Footer>
      </form>          
    </Modal>

    <button onClick={() => handleShow()} className="btn btn-outline-dark" title="Article settings">
      <i className="fa fa-cogs" />
    </button>
  </div>

  );
  
}

const mapStateToProps = (state) => {
  //console.log(state.post, props);

  return {
    auth: state.auth.user,
    categories: state.categories,
  }
};

export default connect(mapStateToProps)(PostSettings);
